export const componentSettings = {
  banners: [
    {
      key: "scrollSpeed",
      type: "number",
      label: "mell.settings.banners.scrollSpeed.label",
      placeholder: "mell.settings.banners.scrollSpeed.placeholder",
      min: 0.1,
      max: 5,
      step: 0.1,
      defaultValue: 0.5,
    },
    {
      key: "slideDelay",
      type: "number",
      label: "mell.settings.banners.slideDelay.label",
      placeholder: "mell.settings.banners.slideDelay.placeholder",
      min: 0.5,
      max: 30,
      step: 0.5,
      defaultValue: 4,
    },
    { key: "banners", type: "bannersList" },
  ],
  categories: [{ key: "categories", type: "categoriesList" }],
  gamesRow: [
    {
      key: "categoryKey",
      type: "searchableSelect",
      label: "mell.settings.gamesRow.categoryKey.label",
      placeholder: "mell.settings.gamesRow.categoryKey.placeholder",
      optionsSource: "gamesList",
    },
    {
      key: "customTitle",
      type: "text",
      label: "mell.settings.gamesRow.customTitle.label",
      placeholder: "mell.settings.gamesRow.customTitle.placeholder",
      multiLang: true,
    },
    {
      key: "verticalCards",
      type: "toggle",
      label: "mell.settings.gamesRow.verticalCards.label",
    },
    { key: "twoRows", type: "toggle", label: "mell.settings.gamesRow.twoRows.label" },
  ],
  slotsSwiper: [
    {
      key: "categoryKey",
      type: "searchableSelect",
      label: "mell.settings.slotsSwiper.categoryKey.label",
      placeholder: "mell.settings.slotsSwiper.categoryKey.placeholder",
      optionsSource: "gamesList",
      defaultValue: "slots",
    },
    {
      key: "title",
      type: "text",
      label: "mell.settings.slotsSwiper.title.label",
      placeholder: "mell.settings.slotsSwiper.title.placeholder",
      multiLang: true,
    },
    {
      key: "ctaLink",
      type: "text",
      label: "mell.settings.slotsSwiper.ctaLink.label",
      placeholder: "mell.settings.slotsSwiper.ctaLink.placeholder",
      defaultValue: "/casino/slots",
    },
    {
      key: "ctaLabel",
      type: "text",
      label: "mell.settings.slotsSwiper.ctaLabel.label",
      placeholder: "mell.settings.slotsSwiper.ctaLabel.placeholder",
      multiLang: true,
    },
  ],
  highlightGame: [
    {
      key: "displayText",
      type: "text",
      label: "mell.settings.highlightGame.displayText.label",
      placeholder: "mell.settings.highlightGame.displayText.placeholder",
      multiLang: true,
    },
    { key: "gameId", type: "text", label: "mell.settings.highlightGame.gameId.label", placeholder: "mell.settings.highlightGame.gameId.placeholder" },
    { type: "group", label: "mell.settings.highlightGame.providerGroup.label" },
    {
      key: "providerKey",
      type: "text",
      label: "mell.settings.highlightGame.providerKey.label",
      placeholder: "mell.settings.highlightGame.providerKey.placeholder",
    },
    {
      key: "providerUrl",
      type: "text",
      label: "mell.settings.highlightGame.providerUrl.label",
      placeholder: "mell.settings.highlightGame.providerUrl.placeholder",
    },
  ],
  gamesGrid: [
    {
      key: "categoryKey",
      type: "text",
      label: "mell.settings.gamesGrid.categoryKey.label",
      placeholder: "mell.settings.gamesGrid.categoryKey.placeholder",
    },
    {
      key: "verticalCards",
      type: "toggle",
      label: "mell.settings.gamesGrid.verticalCards.label",
    },
  ],
  latestWins: [
    { key: "minValue", type: "text", label: "mell.settings.latestWins.minValue.label", placeholder: "mell.settings.latestWins.minValue.placeholder" },
    { key: "maxValue", type: "text", label: "mell.settings.latestWins.maxValue.label", placeholder: "mell.settings.latestWins.maxValue.placeholder" },
    { key: "currency", type: "text", label: "mell.settings.latestWins.currency.label", placeholder: "mell.settings.latestWins.currency.placeholder" },
  ],
  middleBanner: [
    {
      key: "title",
      type: "text",
      label: "mell.settings.middleBanner.title.label",
      placeholder: "mell.settings.middleBanner.title.placeholder",
      multiLang: true,
    },
    {
      key: "buttonText",
      type: "text",
      label: "mell.settings.middleBanner.buttonText.label",
      placeholder: "mell.settings.middleBanner.buttonText.placeholder",
      multiLang: true,
    },
    {
      key: "buttonUrl",
      type: "text",
      label: "mell.settings.middleBanner.buttonUrl.label",
      placeholder: "mell.settings.middleBanner.buttonUrl.placeholder",
    },
    { key: "banner", type: "middleBanner" },
  ],
  textBlock: [
    {
      key: "title",
      type: "text",
      label: "mell.settings.textBlock.title.label",
      placeholder: "mell.settings.textBlock.title.placeholder",
      multiLang: true,
    },
    {
      key: "url",
      type: "text",
      label: "mell.settings.textBlock.url.label",
    },
    {
      key: "text",
      type: "textarea",
      label: "mell.settings.textBlock.text.label",
      placeholder: "mell.settings.textBlock.text.placeholder",
      multiLang: true,
    },
  ],
  profileButton: [
    {
      key: "title",
      type: "text",
      label: "mell.settings.profileButton.title.label",
      placeholder: "mell.settings.profileButton.title.placeholder",
      multiLang: true,
    },
    {
      key: "buttonUrl",
      type: "text",
      label: "mell.settings.profileButton.buttonUrl.label",
      placeholder: "mell.settings.profileButton.buttonUrl.placeholder",
    },
    {
      key: "buttonAction",
      type: "text",
      label: "mell.settings.profileButton.buttonAction.label",
      placeholder: "mell.settings.profileButton.buttonAction.placeholder",
    },
    { key: "iconUrl", type: "iconUploader", label: "mell.settings.profileButton.icon.label" },
  ],
  promotion: [
    {
      key: "title",
      type: "text",
      label: "mell.settings.promotion.title.label",
      placeholder: "mell.settings.promotion.title.placeholder",
      multiLang: true,
    },
    {
      key: "text",
      type: "textarea",
      label: "mell.settings.promotion.text.label",
      placeholder: "mell.settings.promotion.text.placeholder",
      multiLang: true,
    },
  ],
  bonus: [
    { key: "banners", type: "bannersList", maxItems: 1, bannerFields: [] },
    { key: "title", type: "text", label: "mell.settings.bonus.title.label", placeholder: "mell.settings.bonus.title.placeholder", multiLang: true },
    {
      key: "subtitle",
      type: "text",
      label: "builder.common.subtitle",
      placeholder: "builder.common.enterSubtitle",
      multiLang: true,
    },
    { key: "text", type: "textarea", label: "mell.settings.bonus.text.label", placeholder: "mell.settings.bonus.text.placeholder", multiLang: true },
    {
      key: "buttonText",
      type: "text",
      label: "mell.settings.bonus.buttonText.label",
      placeholder: "mell.settings.bonus.buttonText.placeholder",
      multiLang: true,
    },
    { key: "buttonUrl", type: "text", label: "mell.settings.bonus.buttonUrl.label", placeholder: "mell.settings.bonus.buttonUrl.placeholder" },
  ],
  top_providers: [
    {
      key: "alphabeticalSort",
      type: "toggle",
      label: "mell.settings.top_providers.alphabeticalSort.label",
    },
    { key: "categories", type: "categoriesList" },
  ],
}
